export default class HaveNotPopupsInPopupStorage extends Error {

}
